import React, { useCallback } from 'react';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useHistory } from 'react-router';
import ManagedAccountPageTopBar
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTopBar';
import {
  getMaxWidthContainerParent,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/styles';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import { useTheme } from '@material-ui/core/styles';
import { FDContentContainer } from '@facet-wealth/design';
import { useBalanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';
import { buildPageLinkByUserType } from 'Views/Page/Content/Templates';
import useUserContext from 'Context/UserContext';
import ManagedAccountPageTabPanel from './ManagedAccountPageTabPanel';
import { useManagedAccountPageContext } from '../Context/ManagedAccountPageContext';
import ManagedAccountPageHeader from './ManagedAccountPageHeader';

const useStyles = buildUseStyles('ManagedAccountPageContent', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(12),
  },
  main: {
    ...getMaxWidthContainerParent({ theme }),
  },
  content: {
    marginTop: theme.spacing(4),
  },
}));

const ManagedAccountPageContent = () => {
  const isMobile = useMobileLayout();
  const history = useHistory();
  useEventTrackingLogEvent({ isPageView: true, nodeName: 'Managed Account Page' });
  const { logHeaderEvent } = useManagedAccountPageEventLogger();
  const classes = useStyles({ isMobile });
  const balanceSheetURL = useBalanceSheetPageURL();
  const theme = useTheme();
  useBackgroundColor(theme.palette.facet.lightGray);
  const { isAgent } = useUserContext();

  const { managedAccountPageResource } = useManagedAccountPageContext();

  const onLeftAction = useCallback(() => {
    logHeaderEvent('View All Accounts');
    history.push(managedAccountPageResource.withRelationship(
      fr.relationships.previousPage.name,
      (rel) => buildPageLinkByUserType(rel.link('related').url(), isAgent),
      () => balanceSheetURL,
    ));
  }, [logHeaderEvent, history, balanceSheetURL]);

  return <>
    <Box className={classes.root} test={'managed-account-page'}>
      <ManagedAccountPageHeader title="Investments" onLeftAction={onLeftAction} />
      <ManagedAccountPageTopBar resource={managedAccountPageResource} />
      <Box className={classes.main}>
        <FDContentContainer maxWidth="xl">
          <Box className={classes.content}>
            <ManagedAccountPageTabPanel />
          </Box>
        </FDContentContainer>
      </Box>
    </Box>
  </>;
};

export default ManagedAccountPageContent;
